import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/styles/index.scss' // global css
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import { Message,Loading } from 'element-ui'
import store from './store'
import {parseTime} from './utils'
import {getToken,setToken,removeToken,setId,getId} from './utils/auth.js'
var AllLoading
Vue.prototype.$parseTime = parseTime
Vue.prototype.getToken = getToken
Vue.prototype.setToken = setToken
Vue.prototype.removeToken = removeToken
Vue.prototype.setId = setId
Vue.prototype.getId = getId

Vue.use(Element, {
  size: 'medium' // set element-ui default size
})
var msgError=function(message) {
  Message.error({
    message: message,
    duration: 3000
  })
}


var msgSuccess = function(message) {
  Message.success({
    message: message,
    duration: 3000
  })
}

var msgInfo = function(message) {
  Message.info({
    message: message,
    duration: 3000
  })
}

var msgWarning = function(message) {
  Message.warning({
    message: message,
    duration: 3000
  })
}
var loading = function(message) {
  AllLoading = Loading.service({
    lock: true,
    text: message,
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

var closeLoading = function() {
  AllLoading.close()
}

Vue.prototype.$modal = {
  msgError: msgError,
  msgSuccess: msgSuccess,
  msgInfo: msgInfo,
  msgWarning: msgWarning,
  loading: loading,
  closeLoading: closeLoading
}


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
